'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');
const components_display_TooltipWrapper_TooltipWrapper = require('../TooltipWrapper/TooltipWrapper.cjs.js');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const avatarGroup = "_avatar-group_1lt12_1";
const count = "_count_1lt12_21";
const styles = {
	avatarGroup: avatarGroup,
	count: count
};

const AvatarGroup = ({ children, size = void 0, max = 3, overflowCopy }) => {
  const childrenArray = React.Children.toArray(children).filter(Boolean);
  const slicedChildren = childrenArray.slice(0, max);
  const remainingChildren = childrenArray.length - slicedChildren.length;
  const overflowTooltip = React.useMemo(() => overflowCopy || `Plus ${remainingChildren} others`, [overflowCopy, remainingChildren]);
  const content = size !== "large" ? React__default.default.createElement("div", { className: styles.count, "data-zds": true }, overflowCopy || `${Math.min(remainingChildren, 999)} others`) : React__default.default.createElement(components_display_TooltipWrapper_TooltipWrapper.TooltipWrapper, { content: overflowTooltip, position: "southeast" }, () => React__default.default.createElement("div", { "aria-label": overflowTooltip, className: styles.count, "data-zds": true }, Math.min(remainingChildren, 999)));
  return React__default.default.createElement(
    "div",
    { className: styles.avatarGroup, "data-size": size, "data-zds": true },
    slicedChildren,
    remainingChildren > 0 && content
  );
};

exports.AvatarGroup = AvatarGroup;
//# sourceMappingURL=AvatarGroup.cjs.js.map
